import React from "react";
import { FaArrowDown, FaEquals, FaArrowUp, FaExclamation } from "react-icons/fa";
import { getPriority } from "../taskConstants";

const ICONS = { low: FaArrowDown, medium: FaEquals, high: FaArrowUp, urgent: FaExclamation };

function PriorityIcon({ priority, showLabel = false }) {
  const p = getPriority(priority);
  if (!p) return null;
  const Icon = ICONS[priority];
  return (
    <span className={`inline-flex items-center gap-1 text-xs font-Medium ${p.className}`} title={p.label}>
      <Icon className="w-3 h-3" aria-hidden="true" />
      {showLabel ? p.label : <span className="sr-only">{p.label}</span>}
    </span>
  );
}

export default PriorityIcon;
